export function HeaderSimple() {
  return (
    <div className='w-full mb-4 flex items-center justify-center'>
      <img src="/img/print/print-logo.png" className='w-40' />
    </div>
  )
}
